import { Spesialmodul } from '../lib/custom-element-base-class'
import { testPositionSticky } from '@nrk/feature-tests'

export class Client extends Spesialmodul {
  connectedCallback() {
    testPositionSticky(supported => {
      if (supported) {
        // Replace noJs class with js
        this.className = this.className.replace('noJs', 'js')
        this._loadCustomElements()
      } else {
        this.simpleErrorReport.sendErrorReport({
          message: 'Warning: This browser does not support `position: sticky`'
        })
      }
    })
  }

  async _loadCustomElements() {
    if (typeof customElements.get('dh-forklaringsscroll') === 'undefined') {
      customElements.define(
        'dh-forklaringsscroll',
        require('./components/forklaringsscroll').default
      )
    }

    if (typeof customElements.get('dh-fs-basis-stegvis-video') === 'undefined') {
      customElements.define(
        'dh-fs-basis-stegvis-video',
        require('@nrk/dh-basis-stegvis-video').default
      )
    }

    if (typeof customElements.get('dh-fs-basis-levende-stillbilde') === 'undefined') {
      customElements.define(
        'dh-fs-basis-levende-stillbilde',
        require('@nrk/dh-basis-levende-stillbilde').default
      )
    }

    if (typeof customElements.get('dh-fs-spesialmodul') === 'undefined') {
      customElements.define(
        'dh-fs-spesialmodul',
        require('./components/backgrounds/spesialmodul').default
      )
    }

    /* Stegvis lottie is only defined if used */
    if (
      this.stegvisLottie &&
      typeof customElements.get('dh-fs-basis-stegvis-lottie') === 'undefined'
    ) {
      customElements.define(
        'dh-fs-basis-stegvis-lottie',
        (await import('@nrk/dh-basis-stegvis-lottie' /* webpackChunkName: "dh-stegvis-lottie" */))
          .default
      )
    }
  }

  get stegvisLottie() {
    return this.hasAttribute('stegvis-lottie')
  }
}
